import { useQuery } from '@tanstack/react-query'
import { endOfDay, format } from 'date-fns'

import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'
import { useCartStore } from '@/stores/cart-store/cartStore'

import { getCalendarDaysForPeriod } from '../api/getCalendarDaysForPeriod'

const THEN_MIN = 600000

export const useCalendarDaysForPeriod = (start?: Date, end?: Date) => {
	const hotelCode = useCartStore.use.location()?.hotelCode
	const roomConfigurations = useCartStore.use.roomConfigurations()
	const promotionCodes = useCartStore.use.promotion()
	const urlQuery = useAppConfigStore.use.urlQuery()

	const isPromotionCodeLoaded = () => {
		if (!urlQuery?.promotionCode) return true

		return Boolean(promotionCodes.code)
	}

	const rooms = roomConfigurations.map((room) => ({
		adults: room.adults,
		children: room.children,
	}))

	return useQuery({
		queryKey: ['GET_CALENDER_DAYS', start, end, hotelCode, promotionCodes.code, rooms],
		queryFn: () =>
			getCalendarDaysForPeriod({
				earliestArrivalDate: format(endOfDay(start!), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
				latestArrivalDate: format(endOfDay(end!), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
				promotionCode: promotionCodes.code ?? null,
				hotelCode: hotelCode!,
				rooms,
			}),
		enabled: Boolean(hotelCode) && Boolean(start) && Boolean(end) && isPromotionCodeLoaded(),
		staleTime: THEN_MIN,
	})
}
